import { useFormContext } from 'react-hook-form'

import { useDebouncedCallback } from '@/hooks'
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext'

import { SelectInput } from '@/components/atoms/inputs/SelectInput'
import { TextInput } from '@/components/atoms'

/** `channel={false}` hides the channel filter where the page fixes it (Point of sale → Offers). */
export const CampaignsFilters = ({ channel = true }: { channel?: boolean }) => {
  const { setValue, control } = useFormContext()
  const hasPos = useFeatureFlags().isFeatureEnabled('pos') && channel

  const debouncedSearch = useDebouncedCallback((value: string) => {
    setValue('filters.search', value)
    setValue('pagination.currentPage', 1)
  }, 400)

  const handleStatusChange = (value: string) => {
    setValue('filters.status', value === 'all' ? null : value)
    setValue('pagination.currentPage', 1)
  }

  const handleChannelChange = (value: string) => {
    setValue('filters.applies_to', value === 'all' ? null : value)
    setValue('pagination.currentPage', 1)
  }

  return (
    <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:items-center">
      <div className="w-full sm:w-64">
        <TextInput
          control={control}
          name="filtersForm.search"
          label=""
          placeholder="Search campaigns"
          onChange={(e) => debouncedSearch(e.target.value)}
        />
      </div>
      <SelectInput
        name="filters.status"
        placeholder="Filter by status"
        className="w-full sm:w-44"
        options={[
          { label: 'All statuses', value: 'all' },
          { label: 'Active',     value: 'active' },
          { label: 'Inactive',   value: 'inactive' },
          { label: 'Archived',   value: 'archived' },
        ]}
        onChange={handleStatusChange}
      />
      {hasPos && (
        <SelectInput
          name="filters.applies_to"
          placeholder="Filter by channel"
          className="w-full sm:w-48"
          options={[
            { label: 'All channels', value: 'all' },
            { label: 'Online store and POS', value: 'both' },
            { label: 'Online store only', value: 'online' },
            { label: 'POS only', value: 'pos' },
          ]}
          onChange={handleChannelChange}
        />
      )}
    </div>
  )
}
